export type DatasetLayout = 'table' | 'grid';
